import {
  createContext,
  useCallback,
  useContext,
  useState,
  useMemo,
  useEffect,
} from "react";
import PropTypes from "prop-types";
import { useUsers } from "common";
import { navbar as mainMenu } from "app/shared/config";
import { navbarPermissionsHelper } from "common/components/Navbar/navHelper";

const NavBarContext = createContext();

export const NavBarProvider = ({ children }) => {
  const { currentUser } = useUsers();

  const initialState = useMemo(
    () => ({
      menuItems: [],
      supplimentalMenuItems: [],
    }),
    [],
  );

  const [navBar, setNavBar] = useState(initialState);

  const getMenuItems = useCallback(() => {
    return [...navBar.menuItems, ...navBar.supplimentalMenuItems];
  }, [navBar]);

  useEffect(() => {
    if (!currentUser.isLoaded) {
      return setNavBar(initialState);
    }
    setNavBar((oldNavBar) => ({
      ...oldNavBar,
      menuItems: navbarPermissionsHelper(
        mainMenu.items,
        currentUser.permissions,
        currentUser.roles,
      ),
    }));
  }, [initialState, currentUser, setNavBar]);

  const addNavItem = useCallback(
    (navItem) => {
      setNavBar((oldNavBar) => ({
        ...oldNavBar,
        supplimentalMenuItems: [...oldNavBar.supplimentalMenuItems, navItem],
      }));
    },
    [setNavBar],
  );

  const clearNavigation = useCallback(() => {
    setNavBar((oldNavBar) => ({
      ...oldNavBar,
      supplimentalMenuItems: [],
    }));
  }, [setNavBar]);

  const contextValue = useMemo(
    () => ({
      navBar,
      addNavItem,
      getMenuItems,
      clearNavigation,
    }),
    [navBar, addNavItem, getMenuItems, clearNavigation],
  );

  return (
    <NavBarContext.Provider value={contextValue}>
      {children}
    </NavBarContext.Provider>
  );
};

NavBarProvider.propTypes = {
  children: PropTypes.node,
};

// Custom hook
export const useNavBar = () => {
  return useContext(NavBarContext);
};
